import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnChanges, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../services/common.service';
import * as moment from 'moment';
import { Pipe, PipeTransform } from '@angular/core';
import { GestionSygetrack } from '../../recylog/application/gestion.sygetrack';
declare var $: any;

@Pipe({
  name: 'maskInput'
})
export class MaskInputPipe implements PipeTransform {


  transform(value: string, showMask: boolean): string {
    if (!showMask) {
      return value;
    }

    value = value + '';
    return `${'*'.repeat(value ? (value.length) : 0)}`;
    //  ${'●'.repeat(4)}
  }

}

@Component({
  selector: 'app-fiche-client',
  templateUrl: './fiche-client.component.html',
  styleUrls: ['./fiche-client.component.css']
})
export class FicheClientComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() client;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Input() addProspect: Boolean;
  @Input() position;
  @Input() isDepuisMenuEnHaut;
  @Input() prospect;
  @Input() isEcoContrat;
  @Input() objClient;
  activeIdString
  @Output() hidefunction = new EventEmitter<any>();
  @Output() updatefunction = new EventEmitter<any>();
  @Output() addfunction = new EventEmitter<any>();
  @Output() updateClientCallBack = new EventEmitter<any>();

  indexSelected: Number = 1;
  total: String = '1';
  txtQuery: string;
  searchCritere: String = '';
  heigthTotal = 1;
  heigthDefautl = 1;
  elt;
  detail;
  showAll: Boolean = false;
  listeContactHisto
  isEmpty: Boolean = true;
  showcht: Boolean = false;
  isRecherche: Boolean = false;
  showFactAuto: Boolean = false;
  create: Boolean = false;
  txtQueryChanged: Subject<string> = new Subject<string>();
  chantier = {};
  listeChantier = [];
  listeagence: any[] = [];
  isEdit: Boolean = false;
  showChampWithTableu: Boolean = false;
  contact: Boolean = false;
  userEcoportail: Boolean = false;
  document: Boolean = false;
  entTravaux: Boolean = false;
  gestionFIPDND: Boolean = false;
  gestionFIPDD: Boolean = false;
  ibanBic: Boolean = false;
  tropPercus: Boolean = false;
  montantsTeom: Boolean = false;
  prixNegocier: Boolean = false;
  nomenclatureNegocier: Boolean = false;
  libelleNegocier: Boolean = false;
  cap: Boolean = false;
  capDND: Boolean = false;
  capClient: Boolean = false;
  limiterExutoire: Boolean = false;

  isGeneral: Boolean = false;
  isCompta: Boolean = false;
  isComm: Boolean = false;
  isFact: Boolean = false;
  isSolde: Boolean = false;
  isSoldeParChantier: Boolean = false;
  isInfoPart: Boolean = false;
  isInfoPartInGeneral: Boolean = false;
  afficherWinCompteArticleTVA: Boolean = false;

  isCreateAgence: Boolean = false;
  isModifAgence: Boolean = false;
  agence: any = {};

  error = '';
  listChampSupp = [];
  listFiliereFact = [];
  listeSociete = [];
  societe;

  activeBtnValiderAdd: Boolean = false;
  checkDoublon: string = 'true';
  URLCreationClient = '';

  //sygetrack
  msgSygetrack = '';
  arg1FuncAfterSygetrack = false; // set isClick=false
  arg2FuncAfterSygetrack; // idChantier
  nomInformatiqueImbrique = 'Sygetrack'; // Par défaut
  @ViewChild('loadingSygetrack') loadingSygetrack;

  persisterListContact = false;
  @ViewChild('tabset') tabset;
  @ViewChild('msg') msg;
  @ViewChild('confirme') confirme;
  @ViewChild('confirmeDuplicate') confirmeDuplicate;
  isClick: Boolean = false;

  constructor(public common: CommonService, private modalService: BsModalService) {
  }

  ngOnInit() {
    // console.log('ngOnInit fiche client');
    // console.log(this.common.activedModule)
    $('style#ficheClientCodeCouleurId').remove();
    console.log($('style#ficheClientCodeCouleurId'))
    this.listChampSupp = this.common.getType('typeChampsupp') || [];
    this.listFiliereFact = this.common.getType('typefiliere') || [];
    this.societe = this.common.local.getObject('paramSociete') || {};
    this.URLCreationClient = this.societe['URLCreationClient'] || '';
    this.common.isFiche = true;
    if (!this.add) {
      if (!this.common.isModifClient) {
        this.edit = false;
      }
      if (this.objClient && this.objClient['id'] && this.objClient['prospectHolding']) {
        this.detail = Object.assign({}, this.objClient);
        if (this.detail.type) {
          this.detail.type.typeclient = this.common.getType('typeclient', this.detail.type.id);
        }

        this.isEmpty = false;
        // console.log(this.isEmpty);
        $('#fiche').trigger('click');
        $('#ficheCltFiche').trigger('click');
        setTimeout(function () {
          $('#ficheinput').focus();
        }, 500);
      } else {
        this.getDetailClient(this.client).then(datas => {

          this.common.parseValueBooleanClient(this.detail)
          if (this.detail.type) {
            this.detail.type.typeclient = this.common.getType('typeclient', this.detail.type.id);
          }
          this.valeurChampsParDefaut();
          this.printChamps();
          this.isEmpty = false;
          // console.log(this.isEmpty);
          $('#fiche').trigger('click');
          $('#ficheCltFiche').trigger('click');
          setTimeout(function () {
            $('#ficheinput').focus();
          }, 500);
        });
      }

    } else {
      this.clickCreerBtn();
    }
    this.isGeneral = this.isOngletGeneralVisible();
    this.isCompta = this.isOngletComptaVisible() && this.common.activedModule !== 3 && this.common.activedModule !== 4 && this.common.activedModule !== 7;
    this.isComm = this.isOngletCommVisible() && this.common.activedModule !== 3 && this.common.activedModule !== 4 && this.common.activedModule !== 7;
    this.isFact = this.isOngletFactVisible() && this.isEcoContrat;
    this.isSoldeParChantier = this.societe.soldeParChantier ? true : false;
    let user = this.common.local.getObject('userDetail') || {};
    const isDroitregisseur = ((user['clefDroit5'] & 0x00080000) !== 0) ? true : false;
    //Pas 193605 mais 197255
    // ((this.common.activedModule === 3 && this.common.activedModule !== 4) || this.isDepuisMenuEnHaut) &&
    this.isSolde =  this.isOngletSoldeVisible() && !this.isSoldeParChantier ? ((this.societe.clientCollectivite && !isDroitregisseur) ? false : true) : false;
    this.isInfoPart = (this.common.activedModule === 4 || this.common.activedModule === 7) && !this.societe.ecopolFicheClient1Onglet
      && this.isOngletInfoPartVisible() && !this.isSoldeParChantier ? true : false;
    this.isInfoPartInGeneral = (this.common.activedModule === 4 || this.common.activedModule === 7) && this.societe.ecopolFicheClient1Onglet
      && this.isOngletInfoPartVisible() ? true : false;

    this.getNomInformatiqueEmbarque();

  }

  getNomInformatiqueEmbarque() {
    if (this.common.isSiteSygetrack()) {
      const ctrl = this;
      GestionSygetrack.getNomInformatiqueEmbarque(this.common).then(datas => {
        ctrl.nomInformatiqueImbrique = datas.data;
      });
    }
  }

  isInformatiqueEmbarqueSimplicity() {
    return this.nomInformatiqueImbrique == 'Simplicity';
  }

  ngAfterViewInit() {
    // this.isEmpty = false;
  }

  ngOnChanges(changes) {
    if (this.isDepuisMenuEnHaut && this.add) {
      this.isEmpty = false;
      this.detail = {};
      this.clean();
      this.edit = true;
    }
    // console.log(changes)

    /*
    if (this.isDepuisMenuEnHaut && !this.add && this.client) {
      // console.log('xxxxx');
      // console.log(this.detail);
      this.fermerTousLesAutrefenetre();
      this.getDetailClient(this.client).then(datas => {
        if (this.detail.type) {
          this.detail.type.typeclient = this.common.getType('typeclient', this.detail.type.id);
        }
        this.valeurChampsParDefaut();
        this.printChamps();
        this.isEmpty = false;
        $('#fiche').trigger('click');
        setTimeout(function () {
          $('#ficheinput').focus();
        }, 500);
      });
    }
    */

    /*
    console.log('this.add=' + this.add);
    console.log('this.client=' + this.client);
    console.log('this.client=' + this.client);
    */
  }

  getURLCreation() {
    console.log('this.common.activedModule=' + this.common.activedModule);
    let url = this.URLCreationClient;
    let idx = url.indexOf('$U');
    if (idx >= 0) {
      const user = this.common.local.getObject('userDetail') || {};
      url = url.substring(0, idx) + user.login +
        url.substring(idx + 2);
    }

    idx = url.indexOf('$M');
    if (idx >= 0) {
      let m = this.common.activedModule;
      if (m === 0) {
        m = 6;
      }
      url = url.substring(0, idx) + m +
        url.substring(idx + 2);
    }

    return url;
  }

  clickCreerBtn() {
    if (this.URLCreationClient) {
      this.common.openFile(this.URLCreationClient, true);
      this.isClick = false;
      this.hidefunction.emit();
      this.common.isFiche = false;
    } else {
      this.isEmpty = false;
      this.detail = {};
      this.clean();
      this.edit = this.common.isCreateClient ? true : false;
      this.activeBtnValiderAdd = this.common.isCreateClient ? true : false;

      if (this.common.isProspectHolding) {
        if (this.common.activedModule !== 4 && this.common.activedModule !== 7) {
          this.edit = false;
          this.activeBtnValiderAdd = false
        }
      }
      this.detail['paysObjet'] = {
        id: this.societe.pays ? this.societe.pays.id : 0
      };

      if (this.societe.isNumBSDFactDefaut) {
        this.detail['numBSDFacture'] = true;
      }
      if (this.addProspect || this.prospect) {
        this.detail['prospect'] = true;
        this.detail['visibilite'] = {
          id: 3
        };

        this.detail['listModule'] = [{ id: 6, nomClass: 'Module' }]
      }
      this.refreshColor();
      this.getSocieteFille();
    }

    this.chargerListeWidgetEcoPortail();
  }

  /**
   * Par défaut quand on crée un client on met true la visibilité des widgets
   */
  chargerListeWidgetEcoPortail() {
    console.log('Calling chargerListeWidgetEcoPortail()');

    if (this.detail) {
      const param = {
        'servlet': 'DBGestionWidgetEcoPortail',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 1
          }
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        this.detail['listeAssoClientWidgetEcoPortail'] = [];
        if (datas.data && datas.data.length) {
          datas.data.forEach(widgetEcoPortail => {
            this.detail['listeAssoClientWidgetEcoPortail'].push({
              isVisible: true,
              widgetEcoPortail: widgetEcoPortail
            });
          });
        }
      });
    }
  }

  changeIndex(index, direction) {
    const heigth = this.heigthDefautl;
    const total = (this.heigthTotal / this.heigthDefautl).toFixed(0);
    if (0 < index && index <= parseInt(total, 10) + 1) {
      this.indexSelected = index;
      if (direction === 'left') {
        this.elt[0].scrollTop -= heigth;
      } else {
        this.elt[0].scrollTop += heigth;
      }
    }
  }

  editChantier(cht?) {
    this.showChantier();
    this.isEdit = !this.isEdit;
    this.chantier = cht || {};
    // console.log(this.showcht);
  }

  filtreSearch(event) {
    this.changeInput(event.target.value);
  }

  editClient() {
    this.printChamps();
    this.edit = !this.edit;
  }

  closeCht() {
    this.showcht = false;
    this.isEdit = false;
    this.create = false;
    this.chantier = {};
    const adresseAutoBAK = this.societe['rechercheAdresse'] && (this.societe['serviceAdresse'] &&
      this.societe['serviceAdresse'].typeServiceAdresse && this.societe['serviceAdresse'].typeServiceAdresse.id === 2);
    this.common.getDetailBak(adresseAutoBAK, this.detail['clefBAK']);
  }

  addChantier() {
    this.showChantier();
    this.create = !this.create;
    this.chantier = {};
  }

  showAllDetail() {
    this.showAll = !this.showAll;
    const ctrl = this;
    setTimeout(function () {
      ctrl.elt = document.getElementsByClassName('info-client');
      ctrl.heigthTotal = ctrl.elt[0].scrollHeight;
      ctrl.heigthDefautl = (ctrl.elt[0].clientHeight);
    }, 500);
  }

  showFiche() {
    this.isClick = false;
    this.hidefunction.emit();
    this.common.isFiche = false;

    if (this.isDepuisMenuEnHaut) {
      this.edit = false;
      if (this.isDepuisMenuEnHaut && !this.add && this.client) {
        this.fermerTousLesAutrefenetre();
        this.getDetailClient(this.client).then(datas => {
          if (this.detail.type) {
            this.detail.type.typeclient = this.common.getType('typeclient', this.detail.type.id);
          }

          this.isEmpty = false;
          $('#fiche').trigger('click');
          setTimeout(function () {
            $('#ficheinput').focus();
          }, 500);
        });
      }

    }
  }

  chargerDetailClientRefact(clientRefact) {
    console.log('Calling chargerDetailClientRefact()');
    const requette = 9;


    return this.common.appelComboK3Fct(requette, clientRefact.id).then(datas => {
      if (datas.data && datas.data.length) {
        clientRefact['libelleObjetEntite'] = datas.data[0].libelleObjetEntite;
      }
    });
  }

  getDetailClient(id) {
    console.log('Calling getDetailClient()');

    const param = {
      'servlet': 'DBGetClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': id || 0
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'LOAD_CHANTIER': {
          'typeParam': 'boolean',
          'valeur': false
        },
        'LOAD_CONTACT': {
          'typeParam': 'boolean',
          'valeur': false
        }
      }
    };



    return this.common.post('', { param: param }).then(datas => {
      this.detail = datas.data[0];
      this.refreshColor();

      if (this.detail['dateValiditeNegociantClient']) {
        this.detail['dateValiditeNegociantClient'] = moment(this.detail['dateValiditeNegociantClient'],
          'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
      }
      this.getLogo();

      if (this.societe && this.societe.gestionClientHolding &&
        this.societe.isFactIntersociete && this.common.activedModule !== 4) {
        this.getSocieteFille();
      }
      const type = this.common.getType('typeClient') || [];
      type.forEach(elt => {
        if (this.detail['type'] && elt.id === this.detail['type'].id) {
          this.detail['type'] = elt;
        }
      });
      const listTypeflux = this.common.getType('typeFlux')
      const typeflux = this.detail.typeFlux ? this.detail['typeFlux'].id : 0;
      listTypeflux.forEach(element => {
        if (typeflux === element.id) {
          this.detail['typeFlux'] = element
        }
      });
      if (this.detail.clientRefact && this.detail.clientRefact.id) {
        this.chargerDetailClientRefact(this.detail.clientRefact);
      }

      return this.getLog(id).then(data => {
        this.detail['log'] = data;
        return this.getChampSuppl(id).then(elt => {
          this.detail['ChampsClientSupp'] = elt || [];
          return this.getfiliere(id).then(element => {
            this.detail['ChampsFiliere'] = element || [];

            this.listFiliereFact.forEach(filiereFact => {
              this.detail['ChampsFiliere'] = this.detail['ChampsFiliere'] || [];
              this.detail['ChampsFiliere'].forEach(fil => {
                if (fil.libelle === filiereFact.libelle) {
                  filiereFact.actif = true;
                  filiereFact.valeur = fil.codeClient;
                }
              });
            });

            this.listChampSupp.forEach(champSupp => {
              this.detail['ChampsClientSupp'] = this.detail['ChampsClientSupp'] || []
              this.detail['ChampsClientSupp'].forEach(champ => {
                if (champ.nomChamp === champSupp.nom) {
                  champSupp.actif = true;
                  champSupp.valeur = champ.valeur;
                }
              });
            });

            this.changeFiliere();
          });
        });
      });
    });
  }

  // parseValue(detail) {

  // }

  getLogo() {
    const param = {
      'servlet': 'DBGestionLogo',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'TABLE': 'clients',
        'COLONNE': 'logoSociete',
        'COLONNE_CLEF': 'clefClient',
        'CLEF': {
          'typeParam': 'int',
          'valeur': this.detail['id'] || 0
        },
      }
    };

    if (this.detail['id']) {
      return this.common.post('', { param: param }).then(datas => {
        this.detail['logo'] = datas.data;
        this.detail['fichierLogo'] = {};
      });
    }
  }

  saveLogo(id) {
    const param = {
      'servlet': 'DBGestionLogo',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'TABLE': 'clients',
        'COLONNE': 'logoSociete',
        'COLONNE_CLEF': 'clefClient',
        'CLEF': {
          'typeParam': 'int',
          'valeur': id || 0
        },
        'FICHIER': this.detail['fichier']
      }
    };
    if (this.detail['fichier']) {
      return this.common.post('', { param: param });
    }
  }

  saveVisibilite(client) {
    const param = {
      'servlet': 'DBMAJVisibilite',
      'module': 'Recylog',
      'type': 'objet',
      'compression': 'false',
      'data': client
    };
    return this.common.post('', { param: param });
  }

  getLog(id) {
    const param = {
      'servlet': 'DBGestionLogModification',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'forcerSerialisation': 'true',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': '2'
        },
        'CLEF_RECORD_TABLE': {
          'typeParam': 'int',
          'valeur': id || 0
        },
        'CLEF_TABLE_ECOREC': {
          'typeParam': 'int',
          'valeur': '1'
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      return datas.data;
    });
  }

  getChampSuppl(id) {
    const param = {
      'servlet': 'DBGestionChampsClientSupp',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': '3'
        },
        'CLIENT': {
          'typeParam': 'int',
          'valeur': id || 0
        },
        'CONTACT_CLIENT': {
          'typeParam': 'int',
          'valeur': '0'
        }
      }
    };

    if (id) {
      return this.common.post('', { param: param }).then(datas => {
        return datas.data || [];
      });
    } else {
      return Promise.resolve([]);
    }
  }

  getfiliere(id) {
    const param = {
      'servlet': 'DBGetClientsFiliereFacturation',
      'module': 'Recylog',
      'type': 'string',
      'compression': 'false',
      'data': id || 0
    };

    if (id) {
      return this.common.post('', { param: param }).then(datas => {
        return datas.data || [];
      });
    } else {
      return Promise.resolve([]);
    }
  }

  changeFiliere() {
    this.detail['listFiliereFact'] = [];
    this.detail['listChampsClientSupp'] = [];
    this.listFiliereFact.forEach(elt => {
      if (elt.actif) {
        const FiliereFact = {
          id: elt.id,
          libelle: elt.libelle,
          clientFact: {
            id: this.detail['id'] || '0',
            codeClient: elt.valeur
          }
        };
        this.detail['listFiliereFact'].push(FiliereFact);
      }
    });

    this.listChampSupp.forEach(elt => {
      if (elt.actif) {
        const FiliereFact = {
          id: elt.id,
          nom: elt.nom,
          valeur: elt.valeur
        };
        this.detail['listChampsClientSupp'].push(FiliereFact);
      }
    });

  }

  searchChantier(event) {
    this.detail.listeChantier = [];
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']// id client
        },
        'CRITERE': event || '' // recherche chantier
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        // $('.fiche').trigger('click');
        this.detail.listeChantier = datas.data.length ? datas.data : [];
        this.detail.nbrChantier = datas.data.length;
        this.listeChantier = datas.data;
      }
    });
  }

  showChantier() {
    this.showcht = !this.showcht;
  }

  showFact() {
    this.showFactAuto = !this.showFactAuto;

    if (!this.showFactAuto) {
      this.activeIdString = '3'
    }
  }

  verifParamProspect() {
    const codeProspectAuto = this.common.local.getObject('paramSociete').codeProspectAuto || false;
    if (this.detail['prospect']
      && !codeProspectAuto
      && !this.detail['codeProspect']) {
      console.log('verifParam3 : code prospect obligatoire');

      this.error = 'Le code de prospect du client doit être renseigné.';
      this.common.openModal(this.modalService, this.msg);

      return false;
    }

    return true;
  }

  // Client.java 1104
  verifParam() {
    let codeClientErr = false;
    const isCodeClientAuto = this.common.local.getObject('paramSociete').codeClientAuto || false;
    const siretClientObligatoire = this.common.local.getObject('paramSociete').siretClientObligatoire || false;
    const clefTypeClientParticulier = this.common.local.getObject('paramSociete').typeClientParticulier || 0;
    const codeComptaClientObligatoire = this.common.local.getObject('paramSociete').codeComptaClientObligatoire || false;

    if (this.detail['prospect']) {
      this.detail['codeClient'] = this.detail['codeClient'] || '.'
    }
    // !this.detail['prospect'] &&
    if (!isCodeClientAuto) {
      console.log('verifParam1 : codeClient obligatoire');
      codeClientErr = this.detail['codeClient'] ? false : true;
    }

    if (codeClientErr
      || !this.detail['nomClient']
      || !this.detail['adresse1']
      || !this.detail['codePostal']
      || !this.detail['ville']) {
      console.log('verifParam2');
      console.log('this.detail["nomClient"]=' + this.detail['nomClient']);
      console.log('this.detail["adresse1"]=' + this.detail['adresse1']);
      console.log('this.detail["codePostal"]=' + this.detail['codePostal']);
      console.log('this.detail["ville"]=' + this.detail['ville']);
      return false;
    }
    this.detail['type'] = this.detail['type'] || { id: 0, libelle: '' };

    if (siretClientObligatoire
      && !this.detail['siret']
      && (!this.detail['pays'] || this.detail['pays'] === 'FRANCE')
      && (this.detail['type'].id !== clefTypeClientParticulier)) {
      console.log('verifParam4 : siret obligatoire');
      return false;
    }

    // console.log('this.detail["prospect"]=' + this.detail['prospect']);
    // && !this.detail['prospect']

    if (this.isCompta) { // Compta actif
      if (codeComptaClientObligatoire
        && !this.detail['compteComptable']
        && !this.detail['compteComptableFournisseur']) {
        console.log('verifParam4 : compteComptableFournisseur obligatoire');
        return false;
      }
    }

    return true;
  }

  verifAutreChampsObligatoire() {
    const isHolding = this.common.local.get('isHolding');
    if (isHolding) {
      if (this.common.activedModule !== 4 && this.societe.isFactIntersociete && !this.societe.isSocieteFactAucun && this.detail &&
        (!this.detail.holdingSocieteFille || (this.detail.holdingSocieteFille && !this.detail.holdingSocieteFille.id))) {
        this.error = 'La soc. fact doit \u00eatre renseign\u00e9';
        this.common.openModal(this.modalService, this.msg);
        return false;
      }
    }

    return true;
  }

  afficherMessageChampsObligatoires() {
    // console.log('is',)
    const isComptaClientObligatoire = this.common.local.getObject('paramSociete').codeComptaClientObligatoire && this.isCompta ? true : false;

    this.error = 'Les champs : \n \n' +
      '- Nom, \n' +
      '- Code, \n' +
      '- Tel, \n' +
      '- Adresse, \n' +
      '- Code Postal, \n' +
      '- Ville \n' +
      `- SIRET  ${isComptaClientObligatoire ? '\n' : '\n\n'} ` +
      `${isComptaClientObligatoire ? '- Compte Comptable \n\n' : ''}` +
      'de la partie Client doivent ' +
      'obligatoirement \u00eatre renseign\u00e9s.';
    this.common.openModal(this.modalService, this.msg);
  }

  validateChampMail() {
    if (this.common.visibleChamp) {
      this.error = "";
      if (this.common.visibleChamp.clt8) {
        if (this.detail['mail'] && this.detail['mail'] != '') {
          if (!this.common.validatePatternMail(this.detail['mail'])) {
            this.error = "La valeur du champs mail est invalide";
          }
        }
      }
      if (this.common.visibleChamp.clt207) {
        if (this.detail['mailBSDD'] && this.detail['mailBSDD'] != '') {
          if (!this.common.validatePatternMail(this.detail['mailBSDD'])) {
            this.error = "La valeur du champs mail BSDD est invalide";
          }
        }
      }

      if (this.common.visibleChamp.clt31) {
        if (this.detail['mailFacturation'] && this.detail['mailFacturation'] != '') {
          if (!this.common.validatePatternMail(this.detail['mailFacturation'])) {
            this.error = "La valeur du champs mail Env Fact est invalide";
          }
        }
      }
      if (this.common.visibleChamp.clt29) {
        if (this.detail['mailResponsable'] && this.detail['mailResponsable'] != '') {
          if (!this.common.validatePatternMail(this.detail['mailResponsable'])) {
            this.error = "La valeur du champs mail Mail Resp  est invalide";
          }
        }
      }
      return this.error;

    }
  }

  addClient(addFiche?, retourConfirm?) {
    if (!this.verifParam()) {
      this.afficherMessageChampsObligatoires();
      return Promise.resolve(false);
    }

    if (this.detail['nomClient'] && this.detail['nomClient'].includes('/')) {
      this.error = `Le champ Nom ne doit pas contenir le caract\u00e8re /`;
      this.common.openModal(this.modalService, this.msg);
      return Promise.resolve(false);
    }

    if (!this.verifParamProspect()) {
      return Promise.resolve(false);
    }

    if (!this.verifAutreChampsObligatoire()) {
      return Promise.resolve(false);
    }

    const validateChampMail = this.validateChampMail();
    if (validateChampMail && validateChampMail != "") {
      this.error = validateChampMail;
      this.common.openModal(this.modalService, this.msg);
      return Promise.resolve(false);
    }

    if (!this.detail['id']) {
      this.detail['isNonSoumisFIP'] = this.detail['isNonSoumisFIP'] || false;
      this.detail['user'] = this.common.user[0];
      this.detail['jourFacturation'] = this.detail['jourFacturationDefini'] ? this.detail['jourFacturation'] : false;
      this.detail['jourFacturationDefini'] = this.detail['jourFacturation'] ? true : false;
      if (this.prospect || this.addProspect) {
        this.detail['prospect'] = true;
      }

      if (this.common.visibleChamp && this.common.activedModule === 4) {
        if (this.common.visibleChamp.clt158) {
          const idTypeClient = this.detail['type'] ? this.detail['type'].id || 0 : 0;
          const clefTypeClientParticulier = this.societe['typeClientParticulier'] || 0;
          if (idTypeClient === clefTypeClientParticulier && (!this.detail['prenom'] || this.detail['prenom'] === '')) {
            this.error = 'Le champ Prénom est obligatoire';
            this.common.openModal(this.modalService, this.msg);
            return Promise.resolve(false);
          }
        }
      }


      if (this.isInfoPart) {
        if (this.detail['dateNaissance']) {
          this.common.formatDateSaisiManuel(this.detail['dateNaissance'], this.detail, 'dateNaissance');
        }
        this.detail['dateNaissance'] = this.detail['dateNaissance'] && this.detail['dateNaissance'] !== ''
          ? this.detail['dateNaissance'] : '31/12/9999';
        if (this.common.isDate(this.detail['dateNaissance'].replace(' 00:00:00', '')) === 'Date invalide') {
          this.error = 'La valeur du champs \'Date de naissance\' est incorrecte';
          this.common.openModal(this.modalService, this.msg);
          return Promise.resolve(false);
        }
        if (this.common.visibleChamp) {
          if (this.common.visibleChamp.clt137) {
            if (this.detail['dateIdentite']) {
              this.common.formatDateSaisiManuel(this.detail['dateIdentite'], this.detail, 'dateIdentite');
            }
            if (!this.detail['dateIdentite'] || this.detail['dateIdentite'] === '') {
              this.error = 'Le champ date d\'émission est obligatoire';
              this.common.openModal(this.modalService, this.msg);
              return Promise.resolve(false);
            } else if (this.common.isDate(this.detail['dateIdentite']) === 'Date invalide') {
              this.error = 'La valeur du champs \'Date d\'émission\' est incorrecte';
              this.common.openModal(this.modalService, this.msg);
              return Promise.resolve(false);
            }
          } else {
            this.detail['dateIdentite'] = this.detail['dateIdentite'] &&
              this.detail['dateIdentite'] !== '' ? this.detail['dateIdentite'] : '31/12/9999';
          }

          if (this.common.visibleChamp.clt138) {
            if (this.detail['dateValiditeIdentite']) {
              this.common.formatDateSaisiManuel(this.detail['dateValiditeIdentite'], this.detail, 'dateValiditeIdentite');
            }
            if (!this.detail['dateValiditeIdentite'] || this.detail['dateValiditeIdentite'] === '') {
              this.error = 'Le champ date de validité est obligatoire';
              this.common.openModal(this.modalService, this.msg);
              return Promise.resolve(false);
            } else if (this.detail['dateValiditeIdentite'] &&
              this.common.isDate(this.detail['dateValiditeIdentite']) === 'Date invalide') {
              this.error = 'La valeur du champs \'Date de validité\' est incorrecte';
              this.common.openModal(this.modalService, this.msg);
              return Promise.resolve(false);
            }
          } else {
            this.detail['dateValiditeIdentite'] = this.detail['dateValiditeIdentite'] &&
              this.detail['dateValiditeIdentite'] !== '' ? this.detail['dateValiditeIdentite'] : '31/12/9999';
          }
        } else {
          this.detail['dateValiditeIdentite'] = this.detail['dateValiditeIdentite'] &&
            this.detail['dateValiditeIdentite'] !== '' ? this.detail['dateValiditeIdentite'] : '31/12/9999';
          this.detail['dateIdentite'] = this.detail['dateIdentite'] &&
            this.detail['dateIdentite'] !== '' ? this.detail['dateIdentite'] : '31/12/9999';
        }
      } else {
        this.detail['dateNaissance'] = this.detail['dateNaissance'] &&
          this.detail['dateNaissance'] !== '' ? this.detail['dateNaissance'] : '31/12/9999';
        this.detail['dateValiditeIdentite'] = this.detail['dateValiditeIdentite'] &&
          this.detail['dateValiditeIdentite'] !== '' ? this.detail['dateValiditeIdentite'] : '31/12/9999';
        this.detail['dateIdentite'] = this.detail['dateIdentite'] &&
          this.detail['dateIdentite'] !== '' ? this.detail['dateIdentite'] : '31/12/9999';
      }

      const client = this.detail;
      client.id = 0;
      client.nomclass = 'Client';
      const verifierDoublonNom = !retourConfirm ? 'true' : 'false';
      const param = {
        'servlet': 'DBSaveClient',
        'module': 'Recylog',
        'type': 'liste',
        'compression': 'false',
        'data': [['DBSaveClient'], client, verifierDoublonNom, {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        }]
      };

      this.isClick = true;
      return this.common.post('', { param: param }).then(datas => {
        this.checkDoublon = 'true';
        if (this.common.verifySession(datas)) {
          // if (datas.data && datas.data[0] && datas.data[0] !== 'ERR_SETTING_TABLE_0') {
          if (datas.data !== null) {
            const clientRetour = datas.data[0];
            if (clientRetour && clientRetour.id) {
              if (this.isDepuisMenuEnHaut) {
                this.common.filtreClient = [{
                  id: datas.data[0].id,
                  libelleObjetEntite: datas.data[0].codeClient + ' / ' + datas.data[0].nomClient,
                  table: 'clients',
                }];
              }
              if (!addFiche) {
                this.addfunction.emit({ id: datas.data[0].id, libelleObjetEntite: datas.data[0].nomClient });
              }
              if (datas.data[0].id) {
                client.id = datas.data[0].id;
                this.saveVisibilite(client);
                this.saveLogo(datas.data[0].id);
                this.common.createLog('1', datas.data[0].id, true);
              }
              if (!addFiche) {
                this.showFiche();
                this.updateClientCallBack.emit();
              }
              return datas.data[0];
            } else {
              // this.error = 'Ce client existe déjà dans la base.';
              this.isClick = false;
              this.common.openModal(this.modalService, this.confirmeDuplicate);
              return datas.data[0];
            }
          } else {
            if (datas.message) {
              this.isClick = false;
              this.error = datas.message;
              this.common.openModal(this.modalService, this.msg);
            }
          }
          // } else {
          //     this.common.openModal(this.modalService, this.confirme);
          //     return datas.data[0];
          // }
        }
      });
    } else {
      this.updateClient(true)
    }
  }

  changeInput(indexSelected) {
    if (indexSelected.length) {
      this.isRecherche = true;
    } else {
      this.isRecherche = false;
    }
    setTimeout(() => {
      var items = $('.info-client .items');
      items.each(function () {
        var texteChamp = $(this).find('.champ').text();
        var regex = new RegExp(indexSelected, 'gi');
        var match = texteChamp.match(regex);
        if (match) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }, 100);
    // $('.info-client .items').show().not(function () {
    //   return matcher.test($(this).find('.champ').text());
    // }).hide();
    /*if (!$('.group1').find('.items:visible').length) {
        $('.group1 h4').hide();
    } else {
        $('.group1 h4').show();
    }
    if (!$('.group2').find('.items:visible').length) {
        $('.group2 h4').hide();
    } else {
        $('.group2 h4').show();
    }
    if (!$('.group3').find('.items:visible').length) {
        $('.group3 h4').hide();
    } else {
        $('.group3 h4').show();
    }*/
  }

  changeRecherche() {
    if (!this.searchCritere.length) {
      this.isRecherche = false;
    }

    setTimeout(function () {
      $('#ficheinput').focus();
    }, 500);
  }

  updateClient(clientAdd?, retourConfirm?) {

    // console.log('upadate_client')
    //  return false;
    console.log("=======updateClient==============")
    if (!this.verifParam()) {
      this.afficherMessageChampsObligatoires();
      return Promise.resolve(false);
    }

    if (this.detail['nomClient'] && this.detail['nomClient'].includes('/')) {
      this.error = `Le champ Nom ne doit pas contenir le caract\u00e8re /`;
      this.common.openModal(this.modalService, this.msg);
      return Promise.resolve(false);
    }

    if (!this.verifParamProspect()) {
      return Promise.resolve(false);
    }

    if (!this.verifAutreChampsObligatoire()) {
      return Promise.resolve(false);
    }

    if (this.common.visibleChamp && this.common.activedModule === 4) {
      if (this.common.visibleChamp.clt158) {
        const idTypeClient = this.detail['type'] ? this.detail['type'].id || 0 : 0;
        const clefTypeClientParticulier = this.societe['typeClientParticulier'] || 0;
        if (idTypeClient === clefTypeClientParticulier && (!this.detail['prenom'] || this.detail['prenom'] === '')) {
          this.error = 'Le champ Prénom est obligatoire';
          this.common.openModal(this.modalService, this.msg);
          return Promise.resolve(false);
        }
      }
    }

    const validateChampMail = this.validateChampMail();
    if (validateChampMail && validateChampMail != "") {
      this.error = validateChampMail;
      this.common.openModal(this.modalService, this.msg);
      return Promise.resolve(false);
    }

    if (this.isInfoPart) {
      if (this.detail['dateNaissance']) {
        this.common.formatDateSaisiManuel(this.detail['dateNaissance'], this.detail, 'dateNaissance');
      }
      this.detail['dateNaissance'] = this.detail['dateNaissance'] && this.detail['dateNaissance'] !== ''
        ? this.detail['dateNaissance'] : '31/12/9999';
      if (this.common.isDate(this.detail['dateNaissance'].replace(' 00:00:00', '')) === 'Date invalide') {
        this.error = 'La valeur du champs \'Date de naissance\' est incorrecte';
        this.common.openModal(this.modalService, this.msg);
        return Promise.resolve(false);
      }

      if (this.common.visibleChamp) {
        if (this.common.visibleChamp.clt137) {
          if (this.detail['dateIdentite']) {
            this.common.formatDateSaisiManuel(this.detail['dateIdentite'], this.detail, 'dateIdentite');
          }
          if (!this.detail['dateIdentite'] || this.detail['dateIdentite'] === '') {
            this.error = 'Le champ date d\'émission est obligatoire';
            this.common.openModal(this.modalService, this.msg);
            return Promise.resolve(false);
          } else if (this.common.isDate(this.detail['dateIdentite'].replace(' 00:00:00', '')) === 'Date invalide') {
            this.error = 'La valeur du champs \'Date d\'émission\' est incorrecte';
            this.common.openModal(this.modalService, this.msg);
            return Promise.resolve(false);
          }
        } else {
          this.detail['dateIdentite'] = this.detail['dateIdentite'] &&
            this.detail['dateIdentite'] !== '' ? this.detail['dateIdentite'] : '31/12/9999';
        }

        if (this.common.visibleChamp.clt138) {
          if (this.detail['dateValiditeIdentite']) {
            this.common.formatDateSaisiManuel(this.detail['dateValiditeIdentite'], this.detail, 'dateValiditeIdentite');
          }
          if (!this.detail['dateValiditeIdentite'] || this.detail['dateValiditeIdentite'] === '') {
            this.error = 'Le champ date de validité est obligatoire';
            this.common.openModal(this.modalService, this.msg);
            return Promise.resolve(false);
          } else if (this.detail['dateValiditeIdentite'] &&
            this.common.isDate(this.detail['dateValiditeIdentite'].replace(' 00:00:00', '')) === 'Date invalide') {
            this.error = 'La valeur du champs \'Date de validité\' est incorrecte';
            this.common.openModal(this.modalService, this.msg);
            return Promise.resolve(false);
          }
        } else {
          this.detail['dateValiditeIdentite'] = this.detail['dateValiditeIdentite'] &&
            this.detail['dateValiditeIdentite'] !== '' ? this.detail['dateValiditeIdentite'] : '31/12/9999';
        }
      } else {
        this.detail['dateValiditeIdentite'] = this.detail['dateValiditeIdentite'] &&
          this.detail['dateValiditeIdentite'] !== '' ? this.detail['dateValiditeIdentite'] : '31/12/9999';
        this.detail['dateIdentite'] = this.detail['dateIdentite'] &&
          this.detail['dateIdentite'] !== '' ? this.detail['dateIdentite'] : '31/12/9999';
      }
    } else {
      this.detail['dateNaissance'] = this.detail['dateNaissance'] &&
        this.detail['dateNaissance'] !== '' ? this.detail['dateNaissance'] : '31/12/9999';
      this.detail['dateValiditeIdentite'] = this.detail['dateValiditeIdentite'] &&
        this.detail['dateValiditeIdentite'] !== '' ? this.detail['dateValiditeIdentite'] : '31/12/9999';
      this.detail['dateIdentite'] = this.detail['dateIdentite'] &&
        this.detail['dateIdentite'] !== '' ? this.detail['dateIdentite'] : '31/12/9999';
    }

    this.detail['user'] = this.common.user[0];
    this.detail['isNonSoumisFIP'] = this.detail['isNonSoumisFIP'] || false;
    this.detail['jourFacturation'] = this.detail['jourFacturationDefini'] ? this.detail['jourFacturation'] : false;
    this.detail['jourFacturationDefini'] = this.detail['jourFacturation'] ? true : false;

    // if (this.detail['prospect']) {
    //     this.detail['prospect'] = true;
    //     this.detail['visibilite'] = {
    //         id: 3
    //     };

    //     this.detail['listModule'] = [{id: 6, nomClass: 'Module'}]
    // }

    this.detail['dateNaissance'] = this.detail['dateNaissance'] &&
      this.detail['dateNaissance'] !== '' ? this.detail['dateNaissance'] : '31/12/9999';
    this.detail['dateValiditeIdentite'] = this.detail['dateValiditeIdentite']
      && this.detail['dateValiditeIdentite'] !== '' ? this.detail['dateValiditeIdentite'] : '31/12/9999';
    this.detail['dateIdentite'] = this.detail['dateIdentite'] &&
      this.detail['dateIdentite'] !== '' ? this.detail['dateIdentite'] : '31/12/9999';

    if (this.detail['listContact']) {
      this.detail['listContact'].forEach(contact => {
        if (contact['listChampsClientSupp']) {
          contact['listChampsClientSupp'].forEach(champs => {
            champs.id = champs.clefChampsClientSupp;
          });
        }
      });
    }

    const client = this.detail;

    client.nomclass = 'Client';
    this.isClick = true;
    const param = {
      'servlet': 'DBUpdateClient',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data':
        [
          ['DBUpdateClient'],
          client, !retourConfirm ? 'true' : 'false',
          {
            'typeParam': 'int',
            'valeur': this.common.user[2]
          },
          {
            'typeParam': 'int',
            'valeur': this.common.user[0]
          },
          {
            'typeParam': 'string', // depuis Angular
            'valeur': 'true'
          },
          {
            'typeParam': 'string', // list contact chargée (on met à jour la table si la liste a été chargé)
            'valeur': this.persisterListContact ? 'true' : 'false'
          }
        ]
    };

    const param_update_client = {
      'CLIENT': client
    }

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data && datas.data[0] && datas.data[0] !== 'ERR_SETTING_TABLE_0') {

          if (this.societe.gestionClientHolding) {
            this.common.DBGestionAppelHolding(param_update_client, 3)
          }
          this.saveVisibilite(client);
          this.saveLogo(client.id);
          if (datas.data !== null) {
            if (this.add) {
              this.addfunction.emit({ id: client.id, libelleObjetEntite: client.nomClient });
            }
            this.common.createLog('1', client.id, false);
            this.showFiche();
            this.persisterListContact = false;
            this.updateClientCallBack.emit();
          }
        } else {
          this.isClick = false;
          this.common.openModal(this.modalService, this.confirme);
        }
      }
    });
  }

  persistContactClient() {
    this.persisterListContact = true;
  }

  saveClientModal() {
    if (!this.detail['id']) {
      this.addClient(false);
    } else {
      this.updateClient(false, true);
    }
  }

  createChantier(event) {
    event.nomclass = 'Chantier';
    event.siteChantier = {
      'id': this.common.user[2]
    };
    if (this.detail['id']) {
      event['clefClient'] = this.detail['id'];
      if (!this.detail['prospectHolding']) {
        const param = {
          'servlet': 'DBSaveChantierHolding',
          'module': 'Recylog',
          'type': 'liste',
          'compression': 'false',
          'data': [['DBSaveChantierHolding'], event, {
            id: this.detail['id'],
            nomclass: 'Client'
          }]
        };
        this.common.post('', { param: param }).then(datas => {
          this.arg1FuncAfterSygetrack = true;

          if (datas.data.length) { // Positionnement clefChantier pour le log
            this.arg2FuncAfterSygetrack = datas.data[0];
          } else {
            this.arg2FuncAfterSygetrack = 0;
          }

          if (datas.data.length && this.common.isSiteSygetrack() && !this.isInformatiqueEmbarqueSimplicity()) {
            this.setPOI(datas.data[0]);
          } else {
            this.suiteRetourUpdateChantier();
          }
        });


      } else {
        this.detail['nomclass'] = 'Client';
        event.id = event.id || 0;
        const paramChantier = {
          'HOLDING_SERVLET': 'DBGestionProspect',
          'HOLDING_MODULE': 'Recylog',
          'HOLDING_TYPE': 'map',
          'HOLDING_COMPRESSION': 'false',
          'CHANTIER': event,
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 8
          },
          'CLIENT': this.detail,
        };
        this.detail['listChantier'] = this.detail['listChantier'] || [];
        return this.common.DBGestionAppelHolding(paramChantier).then(datas => {
          const chantier = event;
          chantier.id = datas.data || 0;
          this.detail['listChantier'].push(chantier);
          this.arg1FuncAfterSygetrack = false;
          if (datas.data.length && this.common.isSiteSygetrack() && !this.isInformatiqueEmbarqueSimplicity()) {
            this.setPOI(datas.data[0]);
          } else {
            this.suiteRetourUpdateChantier();
          }
        });
      }
    } else {
      this.addClient(true).then(data => {
        if (data && data.id) {
          this.detail = data;
          event['clefClient'] = this.detail['id'];
          const param = {
            'servlet': 'DBSaveChantierHolding',
            'module': 'Recylog',
            'type': 'liste',
            'compression': 'false',
            'data': [['DBSaveChantierHolding'], event, {
              id: this.detail['id'],
              nomclass: 'Client'
            }]
          };
          this.common.post('', { param: param }).then(datas => {
            this.arg1FuncAfterSygetrack = true; // set isClick=false;
            this.arg1FuncAfterSygetrack = false;

            if (datas.data.length) { // Positionnement clefChantier pour le log
              this.arg2FuncAfterSygetrack = datas.data[0];
            } else {
              this.arg2FuncAfterSygetrack = 0;
            }

            if (datas.data.length && this.common.isSiteSygetrack() && !this.isInformatiqueEmbarqueSimplicity()) {
              this.setPOI(datas.data[0]);
            } else {
              this.suiteRetourUpdateChantier();
            }
          });
        } else {
          this.editChantier();
          this.create = false;
          this.isClick = false;
          this.chantier = {};
          this.closeCht();
        }
      })
    }
  }

  champWithTable() {
    this.showChampWithTableu = !this.showChampWithTableu;
  }

  showListContact() {
    this.champWithTable();
    this.contact = !this.contact;
  }

  showUserEcoportail() {
    this.champWithTable();
    this.userEcoportail = !this.userEcoportail;
  }

  showDocument() {
    this.champWithTable();
    this.document = !this.document;
  }

  showEntTravaux() {
    this.champWithTable();
    this.entTravaux = !this.entTravaux;
  }

  showGestionFIPDND() {
    this.champWithTable();
    this.gestionFIPDND = !this.gestionFIPDND;
  }

  showGestionFIPDD() {
    this.champWithTable();
    this.gestionFIPDD = !this.gestionFIPDD;
  }

  showIBANBIC() {
    this.champWithTable();
    this.ibanBic = !this.ibanBic;
  }

  showTropPercus() {
    this.champWithTable();
    this.tropPercus = !this.tropPercus;
    // $('#fiche').trigger('click');
  }

  showMontantsTeom() {
    this.champWithTable();
    this.montantsTeom = !this.montantsTeom;
  }

  showPrixNego() {
    this.champWithTable();
    this.prixNegocier = !this.prixNegocier;
  }

  showNomenclature() {
    this.champWithTable();
    this.nomenclatureNegocier = !this.nomenclatureNegocier;
  }

  showLibelleNego() {
    this.champWithTable();
    this.libelleNegocier = !this.libelleNegocier;
  }

  showCap() {
    this.champWithTable();
    this.cap = !this.cap;
  }

  showCapDND() {
    this.champWithTable();
    this.capDND = !this.capDND;
  }

  showCapClient() {
    this.champWithTable();
    this.capClient = !this.capClient;
  }

  showLimiteExu() {
    this.champWithTable();
    this.limiterExutoire = !this.limiterExutoire;
  }

  isOngletGeneralVisible() {
    let visible = false;
    const listGen = [1, 2, 170, 158, 176, 5, 26, 37, 6, 7, 8, 9, 10, 11, 12, 13, 14, 25, 35, 180,
      15, 16, 17, 18, 19, 20, 21, 185, 186, 187, 188, 189, 200, 201, 27, 28, 32, 29, 30, 31, 171,
      22, 23, 24, 33, 38, 47, 204, 39, 214, 215, 227, 181, 182, 206, 207, 228]

    listGen.forEach(elt => {
      const param = 'clt' + elt;
      if (this.common.visibleChamp[param]) {
        visible = true;
      }
    })
    return (visible)
  }

  isOngletComptaVisible() {
    let visible = false;
    const listCompta = [212, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 67, 68]

    listCompta.forEach(elt => {
      const param = 'clt' + elt;
      if (this.common.visibleChamp[param]) {
        visible = true;
      }
    })
    return (visible)
  }

  isOngletCommVisible() {
    let visible = false;
    const listComm = [69, 70, 71, 72, 89, 90, 73, 81, 82, 83, 87, 88, 20, 114, 129, 111, 112, 113, 75, 76, 77,
      79, 107, 108, 109, 160, 110, 203, 115, 116, 169, 130, 165, 166, 91, 92, 93, 94, 95, 96, 98, 99, 100,
      131, 97, 101, 132, 102, 104, 105, 106, 117, 118, 119, 120, 121, 122, 125, 161, 123, 162, 163, 127,
      164, 177, 179, 202, 208, 126, 133];

    listComm.forEach(elt => {
      const param = 'clt' + elt;
      if (this.common.visibleChamp[param]) {
        visible = true;
      }
    })
    return (visible)
  }

  isOngletFactVisible() {
    let visible = false;
    const listFact = [149, 150];

    listFact.forEach(elt => {
      const param = 'clt' + elt;
      if (this.common.visibleChamp[param]) {
        visible = true;
      }
    })
    return (visible)
  }

  isOngletSoldeVisible() {
    let visible = false;
    const listComm = [129, 145, 146, 147, 100, 178, 73, 148];

    listComm.forEach(elt => {
      const param = 'clt' + elt;
      if (this.common.visibleChamp[param]) {
        visible = true;
      }
    })
    return (visible)
  }

  isOngletInfoPartVisible() {
    let visible = false;
    const listComm = [67, 134, 135, 136, 137, 138, 139, 141, 159, 142, 143];

    listComm.forEach(elt => {
      const param = 'clt' + elt;
      if (this.common.visibleChamp[param]) {
        visible = true;
      }
    })
    return (visible)
  }

  createAgence() {
    this.isCreateAgence = !this.isCreateAgence;
    this.agence = {};
    if (!this.isCreateAgence) {
      const adresseAutoBAK = this.societe['rechercheAdresse'] && (this.societe['serviceAdresse'] &&
        this.societe['serviceAdresse'].typeServiceAdresse && this.societe['serviceAdresse'].typeServiceAdresse.id === 2);
      this.common.getDetailBak(adresseAutoBAK, this.detail['clefBAK']);
    }

  }

  editAgence(event) {
    if (event) {
      event.libelleObjetEntite = event.nom;
      this.agence = event;
    }

    this.isModifAgence = !this.isModifAgence;
    if (!this.isModifAgence) {
      const adresseAutoBAK = this.societe['rechercheAdresse'] && (this.societe['serviceAdresse'] &&
        this.societe['serviceAdresse'].typeServiceAdresse && this.societe['serviceAdresse'].typeServiceAdresse.id === 2);
      this.common.getDetailBak(adresseAutoBAK, this.detail['clefBAK']);
    }
  }

  getValue(event) {
    event.libelleObjetEntite = event.nom;
    this.agence = event;
  }

  getAgence(event?) {
    // selon client
    const param = {
      'servlet': 'DBAgenceGet',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.client ? (this.client.id || 0) : '0'
        },
        'CRITERE': event || ''
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.listeagence = datas.data;
    });
  }

  async getSocieteFille() {
    // console.log('getSocieteFille() called');
    const param = {
      'OPERATION': {
        'typeParam': 'int',
        'valeur': 1
      },
      'SOUS_OPERATION': {
        'typeParam': 'int',
        'valeur': 2
      },
    };

    const isHolding = this.common.local.get('isHolding');
    if (isHolding) {
      await this.common.DBGestionParamHoldingAngular(param).then(dt => {
        this.listeSociete = [{ id: 0, libelle: 'Aucun', libelleObjetEntite: 'Aucun', nom: 'Aucun' }];

        if (dt.data !== null) {
          this.listeSociete = [...this.listeSociete, ...dt.data];

          this.listeSociete.forEach(elt => {
            elt.libelle = elt.nom;
            elt.libelleObjetEntite = elt.libelle;

            if (this.detail && this.detail.holdingSocieteFille &&
              this.detail.holdingSocieteFille.id && this.detail.holdingSocieteFille.id === elt.id) {
              this.detail.holdingSocieteFille = elt;
            }
          });
        }
      });
    } else {
      return Promise.resolve()
    }
  }

  // FicheClient.java CL000008
  appliquerBackground(claire?) {
    if (!this.detail || !this.detail.id) {
      return '#dbe8f8'; // bleu ciel
    }

    const clefModule = this.common.activedModule;
    console.log('clefModule=' + clefModule);
    const MODULE_ECOPOL = 4;
    const dateValiditeIdentite = this.detail['dateValiditeIdentite'] ?
      moment(this.detail['dateValiditeIdentite'], 'DD/MM/YYYY HH:mm:ss') :
      '';
    console.log(dateValiditeIdentite);

    if (clefModule === MODULE_ECOPOL) {
      console.log('Est module ECOPOL');
      if (dateValiditeIdentite && dateValiditeIdentite.isBefore(moment())) {
        return claire ? '#ffacac' : '#FF0000'; // rouge
      }
    } else {
      const codeBlocage = this.getCodeBlocage(parseInt(this.common.user[2], 10));
      if (codeBlocage !== 0) { // 0 => ConstanteEcorec.CLIENT_NORMAL
        return claire ? '#ffacac' : '#FF0000'; // rouge
      }
    }

    if (this.detail.ayantFactureAPayer) {
      return claire ? '#fff5d0' : '#FFC800'; // jaune (orange)
    } else if (this.detail.dateDernierBonAnterieureA365J) {
      return claire ? '#D6B4FC' : '#5B2C83'; // mauve 
    } else {
      return '#dbe8f8'; // return '#FFFFFF'; // white
    }
  }

  getCodeBlocage(clefsite) {
    const prop = this.getProprieteClientParSite(clefsite);
    if (prop) {
      return prop['codeBlocage'] || 0;
    }

    return this.detail['codeBlocage'] || 0;
  }

  getProprieteClientParSite(clefSite) {
    let p;


    if (!this.detail.listeProprietesParSite) {
      return null;
    }


    this.detail.listeProprietesParSite.forEach(prop => {
      if (prop.site && prop.site.id && prop.site.id === clefSite) {
        p = prop;
      }
    });

    return p;
  }

  refreshColor() {
    const vif = this.appliquerBackground();
    const clair = this.appliquerBackground(true);
    const ficheClientCodeCouleurId = 'ficheClientCodeCouleur';
    console.log('vif=' + vif);
    console.log('clair=' + clair);

    if (document.contains(document.getElementById(ficheClientCodeCouleurId))) {
      document.getElementById(ficheClientCodeCouleurId).remove();
    }

    if (vif !== '#dbe8f8') {
      const sheet = document.createElement('style');
      sheet.setAttribute('id', ficheClientCodeCouleurId);

      //   .info-client .btn-group .input{
      //     border: 1px solid ${this.common.hexToRgbA(clair, 0.3)} !important;
      // }
      sheet.innerHTML = `.info-client .fiche{
                background-color: ${clair} !important;
            }
            .info-client .nav-item, .info-client ul.nav-tabs{
                background-color: ${clair} !important;
            }
            .fiche .info-client .nav-tabs .nav-item.show .nav-link, .info-client .nav-tabs .nav-link.active {
                border-bottom: 2px solid ${vif} !important;
            }
            
            .info-client .btn-group .input::placeholder{
                color: ${vif} !important;
            }
            .info-client .activebtn{
                background-color: ${vif} !important;
            }
            .clientBloquer{
                color: ${vif} !important;
            }
            .info-client .historique{
                color: ${vif}!important;
            }
            .info-client .dropdown-menu {
                border: 1px solid ${clair} !important;
            }
            .info-client .form-control:focus {
                border-color: ${clair}!important;
            }
            .info-client input[type=checkbox]:checked {
                background-color: ${vif} !important;
            }
            `;
      document.body.appendChild(sheet);
    }
  }

  showCompteArticleTVA() {
    this.champWithTable();
    this.afficherWinCompteArticleTVA = !this.afficherWinCompteArticleTVA;
  }

  clean() {
    // console.log('Calling clean()');
    this.detail['nbrFact'] = 0;
    this.detail['nbrBon'] = 1;
    this.detail['nbrBonEcobennes'] = 1;
    this.detail['nbrBA'] = 1;
    this.detail['nbrImpBSD'] = -1;
  }

  valeurChampsParDefaut() {
    // console.log('Calling valeurChampsParDefaut()');
    this.detail['nbrFact'] = this.detail['nbrFact'] ? this.detail['nbrFact'] : 0;
    this.detail['nbrBon'] = this.detail['nbrBon'] ? this.detail['nbrBon'] : 0;
    this.detail['nbrBonEcobennes'] = this.detail['nbrBonEcobennes'] ? this.detail['nbrBonEcobennes'] : 0;
    this.detail['nbrBA'] = this.detail['nbrBA'] ? this.detail['nbrBA'] : 0;
    this.detail['nbrImpBSD'] = this.detail['nbrImpBSD'] ? this.detail['nbrImpBSD'] : 0;
  }

  printChamps() {
    /*
    console.log('nbrFact=' + this.detail['nbrFact'] ? this.detail['nbrFact'] : 0);
    console.log('nbrBon=' + this.detail['nbrBon'] ? this.detail['nbrBon'] : 0);
    console.log('nbrBonEcobennes=' + this.detail['nbrBonEcobennes'] ? this.detail['nbrBonEcobennes'] : 0);
    console.log('nbrBA=' + this.detail['nbrBA'] ? this.detail['nbrBA'] : 0);
    console.log('nbrImpBSD=' + this.detail['nbrImpBSD'] ? this.detail['nbrImpBSD'] : 0);
    */
  }

  fermerTousLesAutrefenetre() {
    console.log('fermerTousLesAutrefenetre')
    this.showChampWithTableu = false;
    this.contact = false;
    this.userEcoportail = false;
    this.document = false;
    this.entTravaux = false;
    this.gestionFIPDND = false;
    this.gestionFIPDD = false;
    this.ibanBic = false;
    this.tropPercus = false;
    this.montantsTeom = false;
    this.prixNegocier = false;
    this.nomenclatureNegocier = false;
    this.libelleNegocier = false;
    this.cap = false;
    this.capDND = false;
    this.capClient = false;
    this.limiterExutoire = false;
    this.afficherWinCompteArticleTVA = false
  }

  // Fermer fenetre sygetrack
  closeSygetrack() {
    this.msgSygetrack = '';
    this.common.closeModal();
    this.suiteRetourUpdateChantier();
  }

  // traitement après click bouton fermer sygetrack
  suiteRetourUpdateChantier() {
    if (!this.chantier['runSaveLieuAfterChantier']) {
      this.editChantier();
      this.create = false;
      this.chantier = {};
      this.closeCht();
    } else {
      this.isEdit = true;
      this.create = false;
      this.showcht = true;
      delete this.chantier['runSaveLieuAfterChantier']
      this.chantier['id'] = this.arg2FuncAfterSygetrack;
      // appel saveLieuChantier dans info generale
      this.common.triggerMajLieu(true);
    }

    if (this.arg1FuncAfterSygetrack) {
      if (this.arg2FuncAfterSygetrack) { // nouveau clefChantier
        this.common.createLog('108', this.arg2FuncAfterSygetrack, true);
      }

    }
    
    this.isClick = false;
  
  }

  // synchroniser modification chantier sur sygetrack
  setPOI(id) {
    this.common.openModal(this.modalService, this.loadingSygetrack);
    return GestionSygetrack.setPOI(id, this.common).then(datas => {
      if (datas.data && datas.data['erreur']) {
        this.msgSygetrack = datas.data['erreur'];

        // Pour debug
        if (datas.data['url']) {
          console.log('URL SYGETRACK SET_POI : ' + datas.data['url']);
        }
      } else {
        this.closeSygetrack();
      }
    });
  }
}
